// Set thermal efficiency factor (k). Standard for common processes like SMAW is 0.8, GTAW is 0.6, GMAW is 0.8.
// We will use 1.0 (100% efficiency) for a conservative, common calculation unless specified otherwise.
const THERMAL_EFFICIENCY_FACTOR = 1.0;

// Function to round a number to a specified number of decimal places
const round = (num, dp = 1) => parseFloat(num.toFixed(dp));

/**
* Calculates Travel Speed (S) based on length and time.
* S (mm/min) = (Length (mm) / Time (sec)) * 60
* @param {number} length - Weld length in mm.
* @param {number} time - Weld time in seconds.
* @returns {number} Travel speed in mm/min.
*/
function calculateTravelSpeed(length, time) {
    if (time <= 0 || length <= 0) {
        return 0;
    }
    // Convert seconds to minutes (multiply by 60)
    return (length / time) * 60;
}

/**
* Calculates Heat Input (H) in kJ/mm.
* H = k * (V * A * 60) / (S * 1000)
* Where S is in mm/min, V in Volts, A in Amps.
* @param {number} volts - Voltage (V).
* @param {number} amps - Amperage (A).
* @param {number} speed - Travel speed in mm/min.
* @returns {number} Heat input in kJ/mm.
*/
function calculateHeatInput(volts, amps, speed) {
    if (volts <= 0 || amps <= 0 || speed <= 0) {
        return 0;
    }
    // V * A = Power in Watts (J/s)
    // V * A * 60 = Energy in Joules per minute (J/min)
    // (V * A * 60) / 1000 = Energy in Kilojoules per minute (kJ/min)
    // H (kJ/mm) = (kJ/min) / (mm/min)
    const power = volts * amps;
    const numerator = THERMAL_EFFICIENCY_FACTOR * power * 60;
    const denominator = speed * 1000;

    return numerator / denominator;
}

/**
* Main function to read inputs, perform calculations, and update outputs.
*/
function calculateAll() {
    try {
        const time = parseFloat(document.getElementById('weld-time').value) || 0;
        const length = parseFloat(document.getElementById('weld-length').value) || 0;
        const amps = parseFloat(document.getElementById('weld-amps').value) || 0;
        const volts = parseFloat(document.getElementById('weld-volts').value) || 0;
        const travelSpeed = calculateTravelSpeed(length, time);
        console.log("res-speed:", round(travelSpeed));

        // Update Travel Speed Output
        document.getElementById('res-speed').textContent = `${round(travelSpeed).toLocaleString()} mm/min`;

        // Use the calculated travelSpeed for the Heat Input calculation
        const heatInput = calculateHeatInput(volts, amps, travelSpeed);
        console.log("res-heat:", round(heatInput));

        // Update Heat Input Output
        document.getElementById('res-heat').textContent = `${round(heatInput).toLocaleString()} kJ/mm`;
    } catch (e) {
        console.error("Calculator Error:", e);
        // Optionally display a user-friendly error message
        // document.getElementById('heat-input-output').textContent = "ERROR";
    }
}

// --- THE KEY CHANGE FOR EMBEDDING ---
// Use DOMContentLoaded to ensure the script runs only after all HTML elements are available.
document.addEventListener('DOMContentLoaded', () => {
    // Also run calculateAll immediately to set initial values
    calculateAll();

    // 需要监听的 input id
    const inputIds = ['weld-time', 'weld-length', 'weld-amps', 'weld-volts'];

    inputIds.forEach(id => {
        const el = document.getElementById(id);
        if (!el) return;

        // 监听输入变化（推荐）
        el.addEventListener('input', calculateAll);

        // 如果你想兼容手动粘贴/失焦，也可以加：
        el.addEventListener('change', calculateAll);
    });
});

// Ensure calculateAll is globally accessible, even if the oninput attribute is used
window.calculateAll = calculateAll;